export enum BindingState {
    unbound,
    binding,
    bound,
    closed
}